/**
 * @GestionalePD User Dashboard UI
 */
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
// -----------------------------------------------------------------------
import { AppCalendar, AppProfile, AppSurvey } from '../../sections/app';
/**
 * @returns User Dashboard UI
 */
export default function DashboardAppPage() {
  const [currentProfile, setCurrentProfile] = useState('');

  // get user data
  useEffect(() => {
    let data;

    if (localStorage.getItem('userData') !== 'undefined') data = JSON.parse(localStorage.getItem('userData'));

    if (data) {
      const _currentProfile = data.roles.filter((role) => role.last_used);
      setCurrentProfile(_currentProfile);
    }
  }, []);

  if (currentProfile && currentProfile[0].prof_type_name !== 'USER') return <Navigate to={{ pathname: '/' }} />;

  return (
    <div>
      <Helmet>
        <title>Dashboard Utente</title>
      </Helmet>

      <Container maxWidth="xl">
        <Grid container spacing={3}>
          {/* User profile card */}
          <Grid item xs={12} md={7}>
            <AppProfile />
          </Grid>

          {/* User Calendar Event card UI */}
          <Grid item xs={12} md={5}>
            <AppCalendar title="Calendario Eventi" isAdmin={0} />
          </Grid>

          {/* User Survey card UI */}
          {/* <Grid item xs={12} sm={12}>
            <AppSurvey profile={profile} />
          </Grid> */}
        </Grid>
      </Container>
    </div>
  );
}
